// LineJobDrawer's reads and writes (finance-real, the user 2026-10-22): Setup's ceiling for the least margin %, the job's
// claims, and every write its parts make, which the drawer hands its status, fields, review and claims as props: a claim
// is added, pressed open to change its person and amount, or removed from that form (the user 2026-10-23).
import type { UseMutationResult, UseQueryResult } from "@tanstack/react-query";
import { useAddClaim, useClaimSettings, useJobClaims, useRemoveClaim, useUpdateClaim } from "../../hooks/useJobClaims";
import { useSetJobReview, useSetJobStatus, useUpdateJob } from "../../hooks/useLineJobs";
import type { ClaimSettings, JobClaim, JobClaimInput, LineJob, LineJobPatch, LineJobStatusInput, PriceReviewInput } from "../../types";

export interface LineJobDrawerModel {
  /** Setup's ceiling on claims; undefined until it is read. */
  settings: ClaimSettings | undefined;
  claims: UseQueryResult<JobClaim[]>;
  addClaim: UseMutationResult<JobClaim, Error, { jobId: string; input: JobClaimInput }>;
  updateClaim: UseMutationResult<JobClaim, Error, { claimId: string; input: JobClaimInput }>;
  removeClaim: UseMutationResult<JobClaim, Error, string>;
  setStatus: UseMutationResult<LineJob, Error, { jobId: string; input: LineJobStatusInput }>;
  setReview: UseMutationResult<LineJob, Error, { jobId: string; input: PriceReviewInput }>;
  /** The fields' autosave: a refusal shows under its field, never as a toast. */
  updateJob: UseMutationResult<LineJob, Error, { jobId: string; patch: LineJobPatch }>;
}

export function useLineJobDrawer(jobId: string): LineJobDrawerModel {
  const settings = useClaimSettings();
  const claims = useJobClaims(jobId);
  const addClaim = useAddClaim();
  const updateClaim = useUpdateClaim();
  const removeClaim = useRemoveClaim();
  const setStatus = useSetJobStatus();
  const setReview = useSetJobReview();
  const updateJob = useUpdateJob();
  return { settings: settings.data, claims, addClaim, updateClaim, removeClaim, setStatus, setReview, updateJob };
}
